import { render } from "./ReceiptsTable.vue?vue&type=template&id=3c00fcfa"
import script from "./ReceiptsTable.vue?vue&type=script&lang=js"
export * from "./ReceiptsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__